import { Route } from 'config/routes/ProtectedRoute';
import WCWeighbridge from 'views/setup/weighbridge-creation/screens/WCWeighbridge';
import WCWeighbridgeLocationTrace from 'views/setup/weighbridge-creation/screens/WCWeighbridgeLocationTrace';
import WC from 'views/setup/weighbridge-creation/WC';

const wcWeighbridgeRoute: Route = {
    name: 'weighbridge-creation-weighbridge',
    index: true,
    element: <WCWeighbridge />,
};

const wcWeighbridgeLocationTraceRoute: Route = {
    path: 'location',
    name: 'weighbridge-creation-weighbridge',
    element: <WCWeighbridgeLocationTrace />,
};

const wcRoutes: Route[] = [
    {
        path: 'weighbridges/create',
        name: 'weighbridge-creation',
        element: <WC />,
        children: [wcWeighbridgeRoute, wcWeighbridgeLocationTraceRoute],
    },
];

export default wcRoutes;
